<div
  class="top-wrapper"
  [ngClass]="{ hidden: isHidden, loading: isLoading }"
>
  <ng-container
    *ngIf="(state$ | async) as state"
    [ngSwitch]="state.frame"
  >
    <ng-container
      *ngSwitchCase="'trial-remaining-days'"
      [ngTemplateOutlet]="banner"
      [ngTemplateOutletContext]="{
        $implicit: {
          percent: 50,
          icon: 'lock-closed',
          context: 'success',
          title: 'verification-banner.trial-deposit.title' | translate: {days: state.days},
          description: 'verification-banner.trial-deposit.blocking-services' | translate,
          callToAction: 'verification-banner.initial.button' | translate,
          link: '/profile/verification/identity/auto',
          canClose: false,
        }
      }"
    ></ng-container>
    <ng-container
      *ngSwitchCase="'trial-end-today'"
      [ngTemplateOutlet]="banner"
      [ngTemplateOutletContext]="{
        $implicit: {
          percent: 50,
          icon: 'lock-closed',
          context: 'success',
          title: 'verification-banner.trial-today.pass-full' | translate,
          description: 'verification-banner.trial-today.services-block' | translate,
          callToAction: 'verification-banner.initial.button' | translate,
          link: '/profile/verification/identity/auto',
          canClose: false,
        }
      }"
    ></ng-container>
    <ng-container
      *ngSwitchCase="'trial-expired'"
      [ngTemplateOutlet]="banner"
      [ngTemplateOutletContext]="{
        $implicit: {
          percent: 50,
          icon: 'lock-closed',
          context: 'reject',
          title: 'verification-banner.expired.unblock' | translate,
          description: 'verification-banner.expired.description' | translate,
          callToAction: 'verification-banner.expired.button' | translate,
          link: '/profile/verification/identity/auto',
          canClose: false,
        }
      }"
    ></ng-container>
    <ng-container
      *ngSwitchCase="'full-pending'"
      [ngTemplateOutlet]="banner"
      [ngTemplateOutletContext]="{
        $implicit: {
          percent: 50,
          icon: 'pending',
          context: 'pending',
          title: 'verification-banner.pending.title' | translate,
          description: 'verification-banner.pending.description' | translate,
          canClose: false,
        }
      }"
    ></ng-container>
    <ng-container
      *ngSwitchCase="'full-rejected'"
      [ngTemplateOutlet]="banner"
      [ngTemplateOutletContext]="{
        $implicit: {
          percent: 50,
          icon: 'cross',
          context: 'reject',
          title: 'verification-banner.rejected.full-rejected' | translate,
          description: 'verification-banner.rejected.description' | translate,
          callToAction: 'verification-banner.rejected.button' | translate,
          link: '/profile/verification/identity/auto',
          canClose: false,
        }
      }"
    ></ng-container>
    <ng-container
      *ngSwitchCase="'banned'"
      [ngTemplateOutlet]="banner"
      [ngTemplateOutletContext]="{
        $implicit: {
          percent: 100,
          icon: 'cross',
          context: 'reject',
          title: 'verification-banner.banned.title' | translate,
          callToAction: 'verification-banner.banned.button' | translate,
          link: '/profile/verification/identity/banned',
          canClose: false,
        }
      }"
    ></ng-container>
    <ng-container
      *ngSwitchCase="'card'"
      [ngTemplateOutlet]="banner"
      [ngTemplateOutletContext]="{
        $implicit: {
          percent: 0,
          icon: 'card',
          context: 'pending',
          title: 'verification-banner.card.title' | translate,
          description: 'verification-banner.card.description' | translate,
          callToAction: 'verification-banner.card.button' | translate,
          link: '/profile/verification/card',
          canClose: false,
        }
      }"
    ></ng-container>
    <ng-container
      *ngSwitchCase="'completed'"
      [ngTemplateOutlet]="banner"
      [ngTemplateOutletContext]="{
        $implicit: {
          percent: 100,
          icon: 'check3',
          context: 'success',
          title: 'verification-banner.completed.title' | translate,
          description: 'verification-banner.completed.description' | translate,
          canClose: true,
        }
      }"
    ></ng-container>
    <ng-container
      *ngSwitchCase="'full-pending-express-possible'"
      [ngTemplateOutlet]="banner"
      [ngTemplateOutletContext]="{
        $implicit: {
          percent: 50,
          icon: 'pending',
          context: 'pending',
          title: 'verification-banner.pending.title' | translate,
          description: 'verification-banner.pending.pass-express' | translate,
          callToAction: 'verification-banner.pending-express-possible.button' | translate,
          link: '/profile/verification/express',
          canClose: false,
        }
      }"
    ></ng-container>
    <ng-container
      *ngSwitchCase="'full-rejected-express-posible'"
      [ngTemplateOutlet]="banner"
      [ngTemplateOutletContext]="{
        $implicit: {
          percent: 50,
          icon: 'cross',
          context: 'reject',
          title: 'verification-banner.full-rejected.title' | translate,
          description: 'verification-banner.full-rejected.description' | translate,
          callToAction: 'verification-banner.initial.button' | translate,
          link: '/profile/verification/route',
          canClose: false,
        }
      }"
    ></ng-container>
    <ng-container
      *ngSwitchCase="'trial-continue'"
      [ngTemplateOutlet]="banner"
      [ngTemplateOutletContext]="{
        $implicit: {
          percent: 50,
          icon: 'lock-closed',
          context: 'success',
          title: 'verification-banner.continue-express',
          description: 'verification-banner.continue-express.info',
          callToAction: 'verification-banner.continue-express.button' | translate,
          link: '/profile/verification/express',
          canClose: false,
        }
      }"
    ></ng-container>
  </ng-container>
</div>

<ng-template #banner let-params>
  <global-circle-progress
    [progressPercent]="params.percent"
    [iconSrc]="'./assets/img/icons/sprite.svg#' + params.icon"
    [context]="params.context"
  ></global-circle-progress>
  <div class="title-wrapper">
    <h2 [translate]="params.title"></h2>
    <p *ngIf="params.description" [translate]="params.description"></p>
  </div>
  <a *ngIf="params.link" [routerLink]="params.link" class="link--mobile">
    <svg-icon-sprite
      src="./assets/img/icons/sprite.svg#chevron"
    ></svg-icon-sprite>
  </a>
  <a
    *ngIf="params.link"
    [routerLink]="params.link"
    [translate]="params.callToAction"
    class="link--desktop btn-border"
  ></a>
  <svg-icon-sprite
    *ngIf="params.canClose"
    (click)="close()"
    class="close"
    src="./assets/img/icons/sprite.svg#cross"
  ></svg-icon-sprite>
</ng-template>
